import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { AnticipationInfo } from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";
import SlotDefinition from "slotworks/model/slot-definition";
class AnticipationSupplement implements DataProcessorSupplement {

    /**
     * Currently only supports simple scatter bonus win anticipations
     *
     * @param record {Record}
     */
    public process(record: Record) {

        if (SlotDefinition.symbolDefinitions) {
            if (record instanceof SpinRecord) {

                record.anticipations = new AnticipationInfo();

                record.anticipations.reelAnticipations = [false];
                record.anticipations.landSymbols = [];
                record.anticipations.anticipateSymbols = [[]];

                const symbolAnticipations: Map<string, { count: number, anticipate: boolean }> = new Map<string, { count: number, anticipate: boolean }>();

                const reels: string[][] = record.grid;

                for (let reel = 0; reel < reels.length; reel++) {

                    record.anticipations.landSymbols[reel] = [];
                    record.anticipations.anticipateSymbols[reel + 1] = [];

                    let row = -1;

                    for (const symbolId of reels[reel]) {
                        row++;

                        const symbol = SlotDefinition.getSymbolDefinition(symbolId);

                        // Skip if symbol has no anticipation, don't track it
                        if (symbol.matchesMin === 0) {
                            continue;
                        }

                        // Skip if the symbol is not on a valid row
                        if (symbol.validRows && symbol.validRows.indexOf(row) === -1) {
                            continue;
                        }

                        // Update count of symbols hit
                        if (!symbolAnticipations.has(symbolId)) {
                            symbolAnticipations.set(symbolId, { count: 0, anticipate: false });
                        }

                        const symbolAnticipation = symbolAnticipations.get(symbolId);
                        symbolAnticipation.count++;

                        // Only play symbol lands if there is still a chance of winning a bonus
                        const stillChanceToWin = symbolAnticipation.count + (reels.length - (reel + 1)) >= symbol.matchesMin;
                        if (stillChanceToWin) {
                            record.anticipations.landSymbols[reel].push(symbolId);
                        }

                        // Check to see if anticipation is triggered yet
                        if (symbolAnticipation.count >= symbol.anticipation) {
                            // Activate the anticipation
                            symbolAnticipation.anticipate = true;
                        }
                    }

                    // Deactivate anticipation when count goes over max
                    symbolAnticipations.forEach((symbolAnticipation, symbolId) => {
                        const symbol = SlotDefinition.getSymbolDefinition(symbolId);
                        const maxAnticipation = symbol.matchesMax === 0 ? reels.length : symbol.matchesMax;
                        const minAnticipation = symbol.matchesMin;
                        const remainingReels = reels.length - reel - 1;

                        if (symbolAnticipation.count >= maxAnticipation || symbolAnticipation.count + remainingReels < minAnticipation) {
                            symbolAnticipation.anticipate = false;
                        }
                    });

                    record.anticipations.reelAnticipations[reel + 1] = false;

                    // If any anticipations are active, next reel should anticipate
                    symbolAnticipations.forEach((value: { count: number, anticipate: boolean }, key: string) => {
                        const symbolDef = SlotDefinition.getSymbolDefinition(key);

                        if (value.anticipate) {
                            // If the next strip doesn't contain any of the anticipation worthy symbols, it should not anticipate
                            const nextReelStripContainsSymbol = symbolDef.reels.indexOf(reel + 2) > -1;
                            if (nextReelStripContainsSymbol) {
                                record.anticipations.reelAnticipations[reel + 1] = true;
                                record.anticipations.anticipateSymbols[reel + 1].push(key);
                            }
                        }
                    });
                }

                // Second pass for symbols which always anticipate
                for (const symbolDef of SlotDefinition.symbolDefinitions) {
                    if (symbolDef.anticipation === 0 && symbolDef.matchesMin > 0) {
                        for (let reel = 0; reel < reels.length; reel++) {
                            const reelStripContainsSymbol = symbolDef.reels.indexOf(reel + 1) > -1;
                            if (reelStripContainsSymbol) {
                                record.anticipations.reelAnticipations[reel] = true;
                                record.anticipations.anticipateSymbols[reel].push(symbolDef.id);
                            }
                        }
                    }
                }

                // Last "next reel should anticipate" is irrelevant
                record.anticipations.reelAnticipations.pop();
            }
        }
    }
}

export default new AnticipationSupplement();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/supplements/anticipation-supplement.ts